import { Injectable } from '@angular/core';
import { forkJoin, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { AcceptationSecondHolderModel } from '../../models/acceptation-second-holder.model';
import { SecondHolderResponse } from '../../models/sedond-hoder-response.model';
import { SummarySecondHolderModel } from '../../models/summary-second-holder.model';
import { LayoutService } from '../layout/layout.service';
import { MortgageService } from '../mortgage/mortgage.service';

@Injectable()
export class SummarySecondHolderService {
  constructor(
    private commonService: CommonService,
    private _layoutService: LayoutService,
    private _mortgageService: MortgageService,
  ) {}

  public getSummarySecondHolder(): Observable<SummarySecondHolderModel> {
    return forkJoin(
      this._layoutService.getMortgageData(),
      this.getDataSecondHolder(),
      this._mortgageService.simulateLevel2(false),
    ).pipe(
      map(([mortgageData, userData, simulation]) => {
        const response: SummarySecondHolderModel = {
          mortgageAmount: mortgageData.mortgagesData.mortgageAmount,
          savingsMade: mortgageData.mortgagesData.savingsMade,
          termInYears: mortgageData.mortgagesData.termInYears,
          id: mortgageData.id,
          mortgageSimulateResponse: simulation.mortgageSimulateResponse,
          holder: userData.economicStudyDataResponse.economicStudyData.holders[0],
          status: userData.economicStudyDataResponse.status,
        };

        return response;
      }),
      catchError((error) => throwError(() => error)),
    );
  }

  getDataSecondHolder(): Observable<SecondHolderResponse> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/holder/secondary/data/economic`;
    return this.commonService.getVerb(url);
  }

  acceptationSecondHolder(body: AcceptationSecondHolderModel) {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/holder/secondary/acceptation`;
    return this.commonService.postVerb(url, body);
  }

  deleteSecondHolder() {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/holder/secondary`;
    return this.commonService.deleteVerb(url);
  }
}
